/**
 * 滑动切换混入
 * 提供通用的左右滑动切换功能
 */
export default {
  data() {
    return {
      // 触摸相关数据
      touchStartX: 0,
      touchStartY: 0,
      touchEndX: 0,
      touchEndY: 0,
      minSwipeDistance: 50, // 最小滑动距离
    }
  },
  methods: {
    /**
     * 触摸开始事件处理
     * @param {TouchEvent} e - 触摸事件
     */
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    },

    /**
     * 触摸移动事件处理
     * @param {TouchEvent} e - 触摸事件
     */
    onTouchMove(e) {
      // 阻止默认滚动行为
      e.preventDefault()
    },

    /**
     * 触摸结束事件处理
     * @param {TouchEvent} e - 触摸事件
     */
    onTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].clientX
      this.touchEndY = e.changedTouches[0].clientY
      this.handleSwipe()
    },

    /**
     * 处理滑动手势
     */
    handleSwipe() {
      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY

      // 确保是水平滑动而不是垂直滑动
      if (
        Math.abs(deltaX) > Math.abs(deltaY) &&
        Math.abs(deltaX) > this.minSwipeDistance
      ) {
        if (deltaX > 0) {
          // 右滑 - 显示上一张
          this.swipePrev()
        } else {
          // 左滑 - 显示下一张
          this.swipeNext()
        }
      }
    },

    /**
     * 右滑切换到上一项
     * 子组件需要实现此方法或重写此方法
     */
    swipePrev() {
      if (this.swipeIndex > 0) {
        this.swipeIndex--
      } else if (this.enableLoop !== false) {
        // 默认启用循环，除非明确设置为 false
        this.swipeIndex = this.swipeTotal - 1
      }

      // 触发自定义事件
      this.$emit('swipe-change', this.swipeIndex, 'prev')
    },

    /**
     * 左滑切换到下一项
     * 子组件需要实现此方法或重写此方法
     */
    swipeNext() {
      if (this.swipeIndex < this.swipeTotal - 1) {
        this.swipeIndex++
      } else if (this.enableLoop !== false) {
        // 默认启用循环，除非明确设置为 false
        this.swipeIndex = 0
      }

      // 触发自定义事件
      this.$emit('swipe-change', this.swipeIndex, 'next')
    },

    /**
     * 设置滑动配置
     * @param {Object} config - 配置对象
     * @param {number} config.index - 当前索引的属性名
     * @param {number} config.total - 总数的属性名
     * @param {boolean} config.enableLoop - 是否启用循环
     * @param {number} config.minDistance - 最小滑动距离
     */
    setSwipeConfig(config = {}) {
      const {
        index = 'sliderActiveIndex',
        total = 'assetsList',
        enableLoop = true,
        minDistance = 50,
      } = config

      // 动态设置属性映射
      Object.defineProperty(this, 'swipeIndex', {
        get() {
          return this[index]
        },
        set(value) {
          this[index] = value
        },
      })

      Object.defineProperty(this, 'swipeTotal', {
        get() {
          const totalValue = this[total]
          return Array.isArray(totalValue) ? totalValue.length : totalValue
        },
      })

      this.enableLoop = enableLoop
      this.minSwipeDistance = minDistance
    },
  },
}
